import type { IconProps } from './types';

export const CrossIcon: React.FC<IconProps> = (props) => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M5.83301 5.83334L14.1663 14.1667" stroke="currentColor" stroke-width="1.5" />
            <path d="M14.167 5.83334L5.83366 14.1667" stroke="currentColor" stroke-width="1.5" />
        </svg>
    );
};
